import { OfferLinkEditForm } from "components/Forms/OfferLinkEditForm/OfferLinkEditForm.tsx";
import { TenantPage } from "components/UI/TenantPage/TenantPage.tsx";
import { usePaldockTranslation } from "hooks/usePaldockTranslation";
import { useUser } from "hooks/useUser.ts";
import { PermissionEnum, RoleEnum } from "types/enums.ts";
import { FormId } from "types/models.ts";
import { createTenantFileRoute } from "utils/createTenantFileRoute.ts";
import { getOfferEditHeaderItems } from "utils/tenantHeaderItems.ts";

export const Route = createTenantFileRoute(
    "/_authenticated/$tenantSlug/_layout/offer/_layout/edit/$offerId/_layout/link/"
)({
    component: OfferLinkEditPage,
    staticData: {
        permissions: [PermissionEnum.OfferEditLink],
        showInSideMenu: false,
        label: "pages.offer.edit.link.title",
    },
    loader: ({ context: { t } }) => ({
        breadcrumb: t("pages.offer.edit.link.title"),
    }),
});

function OfferLinkEditPage() {
    const { offerId } = Route.useParams();
    const offerLinkFormId = FormId.OfferLinkEditForm;
    const userUtils = useUser();
    const { t } = usePaldockTranslation("pages.offer.edit");

    return (
        <TenantPage
            headerNavigationItems={getOfferEditHeaderItems}
            saveFormId={
                userUtils
                    ?.getActiveTenant()
                    ?.userRoles?.some((role) => [RoleEnum.AdminFree, RoleEnum.AdminBeast].includes(role.name))
                    ? offerLinkFormId
                    : null
            }
            isEdit={true}
            detailLink={
                userUtils
                    ?.getActiveTenant()
                    ?.userRoles?.some((role) => [RoleEnum.AdminFree, RoleEnum.AdminBeast].includes(role.name))
                    ? {
                          to: "/offer/detail/$offerId/link",
                          params: { offerId: offerId },
                          label: t("offer_preview"),
                      }
                    : null
            }
        >
            <OfferLinkEditForm key={offerId} offerId={offerId} />
        </TenantPage>
    );
}
